<template>
  <div class="header">
    <div class="logo">
      <img src="../../../assets/images/logo.png"/>
    </div>

    <div class="steps">
      <template v-for="(step, index) in steps" :key="step.name">
        <div class="step active">
          <StepMarker :current="isCurrent(index)" :done="isDone(index)"/>
          <div class="step-text">{{ step.name }}</div>
        </div>
        <div class="line"
             :class="{start: isCurrent(index) ,
                      done: isDone(index),
                      wait: !isDone(index) && !isCurrent(index)}"
             v-if="!isLastStep(index)">
        </div>
      </template>
    </div>

  </div>
</template>

<script setup>
import StepMarker from "../../../components/StepMarker";
import {ref, toRef} from "vue";

const props = defineProps({
  current: {type: Number, request: true, default: 0},
});

const current = toRef(props, 'current');

const steps = ref([
  {
    name: 'Personal Data',
  },
  {
    name: 'Brand Info',
  },
  {
    name: 'Payment Info',
  },
]);

const isLastStep = index => index === steps.value.length - 1;
const isCurrent = index => current.value === index;
const isDone = index => Number.isInteger(current.value) && current.value > index;
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/theme_variables";

.header {
  display: flex;
  position: relative;
  padding: toRem(24) 0 toRem(16);
  background: $bgBlocks;
}

.logo {
  position: absolute;
  left: toRem(32);
  top: toRem(32);

  img {
    width: toRem(88);
  }
}

.steps {
  display: flex;
  margin: 0 auto;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 500;

  .step-marker {
    margin-bottom: toRem(8);
  }
}

.line {
  width: toRem(280);
  height: toRem(2);
  border-radius: 1px;
  transform: translateY(10px);

  &.start {
    background: linear-gradient(90deg, #2196F3 0%, rgba(33, 150, 243, 0) 31.76%), linear-gradient(0deg, rgba(68, 72, 109, 0.15), rgba(68, 72, 109, 0.15)), rgba(255, 255, 255, 0.15);
  }

  &.done {
    background: linear-gradient(90deg, #2196F3 0%, rgba(33, 150, 243, 0) 31.76%), linear-gradient(0deg, #0F8BFD, #0F8BFD), linear-gradient(0deg, rgba(68, 72, 109, 0.15), rgba(68, 72, 109, 0.15)), rgba(255, 255, 255, 0.15);
  }

  &.wait {
    background: linear-gradient(0deg, rgba(68, 72, 109, 0.15), rgba(68, 72, 109, 0.15)), rgba(255, 255, 255, 0.15);
  }
}

</style>
